export const derivePermissionsFromConfig = (permissions) => {
    if (permissions) {
        return [
            { type: '*Connection', fields: ['*'] },
            { type: '*Edge', fields: ['*'] },
            { type: '*PageInfo', fields: ['*'] },
            { type: '*Payload', fields: ['*'] },
            ...permissions,
        ];
    }
    return [{ type: '*', fields: ['*'] }];
};
//# sourceMappingURL=derivePermissionsFromConfig.js.map